import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import NumberFormat from "react-number-format";
import {
  getCampaigns_Begin,
  setCampaignsEmpty_Begin,
  selectCampaigns,
  toggleCampaignModal,
  getPaymentPlan_Begin,
  setSelectedCampaign,
  checkIfCustomerHasAddress_Begin,
  checkPersonelInformation_Begin,
  selectPaymentPlan,
  sendSmsOfferValidation,
  memberInstallmentControl,
} from "../../../state/ducks/calculation/index";
import { isShowMemberApplications } from "../../../state/ducks/dashboard/index";
import { alertActions } from "../../../state/ducks/alert/index";
import PaymentPlan from "./PaymentPlan";
import { animateScroll } from "react-scroll";
import $ from "jquery";

function formKontrol() {
  var tutar = $("#tutar").val();
  var radiobuttonArac = $("#arac-radiobutton").prop('checked')
  var radiobuttonEv = $("#ev-radiobutton").prop('checked')
  var pesinat = $("#pesinat").val();
  var taksit = $("#taksit").val();
  var durum = 1;
  // Tutar boş mu kontrol
  if (!radiobuttonArac && !radiobuttonEv) {

    durum = 0;
    $("#check_hatamesaj").html("Ev yada Araba birini seçiniz");
  }
  else {
    $("#check_hatamesaj").html("");
  }
  if (tutar == "") {
    durum = 0; // Konu Boş
    $("#tutar").parent().addClass("t-error");
    $("#tutar").next().html("<i class='t-icon-error text-danger'></i>");
    $("#tutar_hatamesaj").html("Tutar boş bırakılamaz.");
  } else {
    $("#tutar").parent().removeClass("t-error");
    $("#tutar").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#tutar_hatamesaj").html("");
  }
  // Peşinat boş mu kontrol
  if (pesinat == "") {
    durum = 0; // Mesaj Boş
    $("#pesinat").parent().addClass("t-error");
    $("#pesinat").next().html("<i class='t-icon-error text-danger'></i>");
    $("#pesinat_hatamesaj").html("Peşinat tutarı boş bırakılamaz.");
  } else {
    $("#pesinat").parent().removeClass("t-error");
    $("#pesinat").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#pesinat_hatamesaj").html("");
  };
  // taksit boş mu kontrol
  if (taksit == "") {
    durum = 0; // Mesaj Boş
    $("#taksit").parent().addClass("t-error");
    $("#taksit").next().html("<i class='t-icon-error text-danger'></i>");
    $("#taksit_hatamesaj").html("Taksit tutarı boş bırakılamaz.");
  } else {
    $("#taksit").parent().removeClass("t-error");
    $("#taksit").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#taksit_hatamesaj").html("");
  };
  return durum;
}
const SmartCalculation = ({
  campaigns,
  setCampaignsEmpty_Begin,
  getCampaigns,
  toggleCampaignModal,
  getPaymentPlan_Begin,
  hasAddress,
  hasPersonalInfo,
  history,
  setSelectedCampaign,
  organizasyonTuruId,
  checkIfCustomerHasAddress_Begin,
  checkPersonelInformation_Begin,
  paymentPlan,
  isShowMemberApp,
  showError,
}) => {
  useEffect(() => {
    setCampaignsEmpty_Begin();
    checkPersonelInformation_Begin();
    checkIfCustomerHasAddress_Begin();

    async function fetchData() {
      const res = await isShowMemberApp();
      const data = await res.data;
      if (data != null && data === false) {
        history.push("/Home/Dashboard");
      }
    }
    fetchData();
  }, []);

  const [calculation, setCalculation] = useState({
    totalAmount: "",
    initialAmount: "",
    installment: "",
    homeOrCar: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCalculation({ ...calculation, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formKontrol() == 0) {
      return false;
    }

    campaigns = [];

    var orgTuruId =
      calculation.homeOrCar == "Ev"
        ? 2
        : calculation.homeOrCar == "Araç"
          ? 1
          : 0;
    const query = `orgTutar=${calculation.totalAmount.replace(
      /\./g,
      ""
    )}&pesinatTutar=${calculation.initialAmount === ""
      ? 0
      : calculation.initialAmount.replace(/\./g, "")
      }&taksitTutar=${calculation.installment.replace(
        /\./g,
        ""
      )}&tumKampanyalar=0&pasifMi=false&taksitliPesinat=false&taksitliOrg=false&ozelKampanyalar=0&web=0&iSube=1&orgTuru=${orgTuruId}`;

    getCampaigns(query);
    $(".kampanya").collapse("hide");
    animateScroll.scrollTo(550);
  };

  const getPaymentplan = (campaign) => {
    
    // $(".kampanya").collapse("hide");
    for (var i = 0; i < campaigns.length; i++) {
      if (campaigns[i].id != campaign.id) {
        $("#kampanya_" + campaigns[i].id).collapse("hide")
      }
    }

    var orgTuruId =
      campaign.organizasyonTuruId == 0 && calculation.homeOrCar == "Ev"
        ? 2
        : campaign.organizasyonTuruId == 0 && calculation.homeOrCar == "Araç"
          ? 1
          : campaign.organizasyonTuruId;
    const query = `firmaId=1&organizasyonTuruId=${orgTuruId}&organizasyonSistemiId=${campaign.organizasyonSistemiId
      }&kampanyaId=${campaign.id}&orgTutar=${campaign.calcOrganizasyonTutari ??
      calculation.totalAmount.toString().replace(/\./g, "")
      }&taksitTutar=${calculation.installment.replace(/\./g, "")}&pesinatTutar=${campaign.organizasyonSistemiId == 3
        ? 0
        : campaign.calcOdenecekPesinat ??
        calculation.initialAmount.replace(/\./g, "")
      }&ciktigiAy=${campaign.calcSonTeslimat
      }&yonetimIskOran=&kampanyaIskOran=&teslimatSonrasiTaksit=&tmpTakTut=${calculation.installment.replace(
        /\./g,
        ""
      )}&takSay=null&btn=null&log=${campaign.logMasterId}`;
    getPaymentPlan_Begin(query, orgTuruId);
  };

  const showPaymentDetailsModal = () => {
    toggleCampaignModal(true);
  };

  const showPaymentDetails = (campaign) => {
    getPaymentplan(campaign);
  };

  const submitApprove = (campaign) => {
    if (hasPersonalInfo.kurumsalMi === true) {
      showError(
        "Yeni Üyelik oluşturmak için lütfen Profilim menüsünde yer alan Müşteri Temsilcinizle iletişime geçiniz."
      );
    } else {
      getPaymentplan(campaign);
      setSelectedCampaign(campaign);

      async function fetchData() {
        var orgSistemiId = campaign.organizasyonSistemiId;
        var orgTuruId = organizasyonTuruId;
        var taksitSayisi = paymentPlan.taksitSayisi;
        const res = await memberInstallmentControl(
          orgTuruId,
          orgSistemiId,
          taksitSayisi
        );
        if (res === null || res === undefined) {
          if (hasPersonalInfo.bilgiEkle) {
            history.push("/Home/PersonalInfo");
          } else if (hasAddress.sehirId === 0 || hasAddress.adresEkle) {
            history.push("/Home/NewAddress");
          } else {
            sendSmsOfferValidation();
            history.push("/Home/SmsVerification");
          }
        } else {
          await showError(res);
          console.log("error", res);
        }
      }
      fetchData();
    }
  };

  return (
    <div className="container-fluid">
      {/* yesil Alan*/}
      <div className="row" style={{ padding: "3% 3% 0 3%" }}>
        <div className="col-12">
          {/* KUTU 1 */}
          <div className="row no-gutters t-kutu t-mavicizgi">
            <div
              className="col bosluk backbottom"
              style={{
                backgroundImage: 'url("/assets/img/backgrounds/back_bottom_mavi.jpg")'
              }}
            >
              {/* içerikler */}
              {/* Başlık */}
              <div className="row no-gutters pb-4">
                <div clss="col-auto">
                  <i className="t-icon-calculator icon" />
                </div>
                <div className="col d-flex flex-column justify-content-center">
                  <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                    Akıllı Hesap
                  </div>
                  <span className="altBaslik">Hesaplama Yap</span>
                </div>
              </div>
              <div className="row no-gutters">
                <div className="col-12 pb-1">
                  <span className="t-icInputTitle pl-3">
                    Ne Almak İstiyorsunuz ?
                  </span>
                </div>
                <div className="col-auto pl-3 d-flex align-items-center pb-3">
                  <input
                    type="radio"
                    id="ev-radiobutton"
                    name="homeOrCar"
                    value="Ev"
                    checked={calculation.homeOrCar === "Ev"}
                    onChange={handleChange}
                    required

                  />
                  <span
                    className="t-icAciklamaYazi"
                    style={{ paddingLeft: 10, position: "relative" }}
                  >
                    EV
                  </span>
                </div>
                <div className="col-auto pl-3 d-flex align-items-center pb-3">
                  <input
                    type="radio"
                    id="arac-radiobutton"
                    name="homeOrCar"
                    value="Araç"
                    style={{ marginLeft: "100px" }}
                    checked={calculation.homeOrCar === "Araç"}
                    onChange={handleChange}
                    required
                  />
                  <span
                    className="t-icAciklamaYazi"
                    style={{ paddingLeft: 10, position: "relative" }}
                  >
                    ARABA
                  </span>

                </div>
              </div>
              <div
                className="row no-gutters col-12 t-icinputHatamesajArea pl-3 pt-1"
                id="check_hatamesaj"
              />
              <div className="row no-gutters">
                {/* TUTAR*/}
                <div className="col-12 pb-1">
                  <span className="t-icInputTitle pl-3">
                    Almak İstediğiniz ev veya arabanın tutarını giriniz.
                  </span>
                </div>
                <div className="col-12">
                  <div className="t-icInput">
                    <div>
                      <strong>₺</strong>
                    </div>

                    <NumberFormat
                      id="tutar"
                      placeholder="Tutar"
                      className="sayi"
                      name="totalAmount"
                      required
                      value={calculation.totalAmount}
                      onChange={handleChange}
                      displayType={"input"}
                      thousandSeparator={"."}
                      decimalSeparator={false}
                      isAllowed={(values) => {
                        const { formattedValue, floatValue } = values;
                        return formattedValue === "" || floatValue <= 20000000;
                      }}
                    />
                    <div />
                  </div>
                </div>
                {/* Hata mesajının geleceği alan*/}
                <div
                  className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                  id="tutar_hatamesaj"
                />
                {/* PEŞİNAT*/}
                <div className="col-12 pb-1">
                  <span className="t-icInputTitle pl-3">
                    Ne kadar peşinat verebilirsiniz ?
                  </span>
                </div>
                <div className="col-12">
                  <div className="t-icInput">
                    <div>
                      <strong>₺</strong>
                    </div>

                    <NumberFormat
                      id="pesinat"
                      placeholder="Peşinat Tutarı"
                      className="sayi"
                      name="initialAmount"
                      required
                      value={calculation.initialAmount}
                      onChange={handleChange}
                      displayType={"input"}
                      thousandSeparator={"."}
                      decimalSeparator={false}
                      isAllowed={(values) => {
                        const { formattedValue, floatValue } = values;
                        return formattedValue === "" || floatValue <= 20000000;
                      }}
                    />
                    <div />
                  </div>
                </div>
                {/* Hata mesajının geleceği alan*/}
                <div
                  className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                  id="pesinat_hatamesaj"
                />
                {/* Taksit*/}
                <div className="col-12 pb-1">
                  <span className="t-icInputTitle pl-3">
                    Aylık ne kadar taksit ödeyebilirsiniz ?
                  </span>
                </div>
                <div className="col-12">
                  <div className="t-icInput">
                    <div>
                      <strong>₺</strong>
                    </div>

                    <NumberFormat
                      id="taksit"
                      placeholder="Taksit Tutarı"
                      className="sayi"
                      name="installment"
                      required
                      value={calculation.installment}
                      onChange={handleChange}
                      displayType={"input"}
                      thousandSeparator={"."}
                      decimalSeparator={false}
                      isAllowed={(values) => {
                        const { formattedValue, floatValue } = values;
                        return formattedValue === "" || floatValue <= 20000000;
                      }}
                    />
                    <div />
                  </div>
                </div>
                {/* Hata mesajının geleceği alan*/}
                <div
                  className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                  id="taksit_hatamesaj"
                />
                {/* Button */}
                <div className="col-12 d-flex justify-content-center pb-3">
                  <button className="t-icButonMavi"
                    onClick={handleSubmit}
                  >
                    <span>Kampanyaları Getir</span>
                    <i className="t-icon-arrow-right2" />
                  </button>
                </div>


              </div>
              {/* içerikler BİTTİ */}
            </div>
            <div className="col-auto renk" />
          </div>
          {/* KUTU 1 BİTTİ */}
        </div>
      </div>
      {/* Duyurlar Baslık*/}
      {/* duyrular Bitti*/}
      {campaigns && (
        <div className="row" style={{ padding: "0 3% 3% 3%" }}>
          <div className="col-12">
            {/* KUTU 1 */}
            <div className="row no-gutters t-kutu t-mavicizgi">
              <div
                className="col bosluk backleft"
                style={{
                  backgroundImage: 'url("/assets/img/backgrounds/back_left_mavi.jpg")'
                }}
              >
                {/* içerikler */}
                {/* Başlık */}
                {/* Başlık */}
                <div className="row no-gutters pb-4 d-flex align-items-center">
                  <div clss="col-auto">
                    <div className="baslik">Size Uygun Kampanyalar</div>
                  </div>
                  {/* <div className="col d-flex justify-content-end">

                    <a
                      className="t-icButonMavi"
                      href="https://esube.eminevim.com/"
                      target="eminevim"
                    >
                      <span>Görüntülü Görüşme Yap</span>
                      <i className="t-icon-arrow-right2" />
                    </a>
                  </div> */}
                </div>
                <div className="row no-gutters">
                  <div className="col-12 t-icYaziFontStandart">
                    {/*ACORDİON MENU*/}
                    {campaigns.map((item) => (
                      <div className="accordion" id="teslimatOnce" key={item.id}>
                        {/* SORU SATIRI  */}
                        <div className="t-icSssCerceve">
                          <div
                            className="row no-gutters sorusatir kampanya"
                            data-toggle="collapse"
                            data-target={`#kampanya_${item.id}`}
                            onClick={() => showPaymentDetails(item)}
                          >
                            <div className="col-12">
                              <strong>Kampanya Teklifi</strong>
                              <br />
                            </div>
                            <div className="col soru">
                              {item.formKampanyaAdi}
                            </div>
                            <div className="col-auto pl-2">
                              <i className="t-icon-keyboard_arrow_down" />
                            </div>
                          </div>
                          <div className="row no-gutters pr-4">
                            <div
                              id={`kampanya_${item.id}`}
                              className="collapse w-100 kampanya"
                              data-parent="#teslimatOnce"
                            >
                              <table
                                className="table table-sm"
                                style={{ width: "100%" }}
                              >
                                <thead>
                                  <tr>
                                    <th scope="col" colSpan={2}>
                                      Teklif özetimiz aşağıdaki gibidir.
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{calculation.homeOrCar} Değeri</td>
                                    <td>
                                      <NumberFormat
                                        value={paymentPlan?.orgTutar}
                                        displayType={"text"}
                                        thousandSeparator="."
                                        decimalSeparator=","
                                        prefix={"₺ "}
                                        decimalScale={2}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Ödeme Peşinatı</td>
                                    <td>
                                      <NumberFormat
                                        value={paymentPlan?.pesinatTutar}
                                        displayType={"text"}
                                        thousandSeparator="."
                                        decimalSeparator=","
                                        prefix={"₺ "}
                                        decimalScale={2}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Organizasyon Ücreti</td>
                                    <td>
                                      <NumberFormat
                                        value={paymentPlan?.orgUcretiKdvDahil}
                                        displayType={"text"}
                                        thousandSeparator="."
                                        decimalSeparator=","
                                        prefix={"₺ "}
                                        decimalScale={2}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Toplam Maliyet</td>
                                    <td>
                                      <NumberFormat
                                        value={paymentPlan?.toplamMaliyet}
                                        displayType={"text"}
                                        thousandSeparator="."
                                        decimalSeparator=","
                                        prefix={"₺ "}
                                        decimalScale={2}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Taksit Sayısı</td>
                                    <td>{paymentPlan?.taksitler.length}</td>
                                  </tr>
                                  {item.id != 999999 && (
                                    <tr>
                                      <td>
                                        Son Teslim Dönemi { }
                                        <i
                                          className="fa fa-info-circle"
                                          aria-hidden="true"
                                          data-toggle="tooltip"
                                          data-placement="right"
                                          title="Bu kampanyayı seçmeniz durumunda teslimatınızı alacağınız son ay"
                                        ></i>
                                      </td>
                                      <td>{paymentPlan?.sonTeslimDonem}</td>
                                    </tr>
                                  )}
                                  {item.id == 999999 && (
                                    <tr>
                                      <td>Teslimat Tarihi</td>
                                      <td>{paymentPlan?.ilkTeslimTarihi}</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                              <div className="w-100 row no-gutters justify-content-center">
                                <div className="col-auto px-1">
                                  <a
                                    className="t-icButtonYesil"
                                    onClick={() => submitApprove(item)}
                                    target="_parent"
                                  >
                                    <span style={{ textAlign: "left" }}>Teklifi Kabul ediyorum, Başvur</span>
                                    <i className="t-icon-arrow-right2" />
                                  </a>
                                </div>
                                <div className="col-auto px-1">
                                  <a
                                    className="t-icButonMavi"
                                    href="#"
                                    onClick={() => showPaymentDetailsModal()}
                                  >
                                    <span>Taksit Detayı</span>
                                    <i className="t-icon-arrow-right2" />
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    ))}

                    {/* /col*/}
                  </div>
                  {/* /row */}
                </div>
                {/* içerikler BİTTİ */}
              </div>
            </div>
            {/* KUTU 1 BİTTİ */}
          </div>
        </div>
      )}
      <PaymentPlan />
    </div>

  );
};

const mapStateToProps = (state) => ({
  campaigns: selectCampaigns(state),
  hasAddress: state.calculation.hasAddress,
  hasPersonalInfo: state.calculation.hasPersonalInfo,
  selectedCampaign: state.calculation.selectedCampaign,
  organizasyonTuruId: state.calculation.orgTuruId,
  paymentPlan: selectPaymentPlan(state),
});

const mapDispatchToProps = (dispatch) => ({
  getCampaigns: (query) => dispatch(getCampaigns_Begin(query)),
  setCampaignsEmpty_Begin: () => dispatch(setCampaignsEmpty_Begin()),
  toggleCampaignModal: (isOpen) => dispatch(toggleCampaignModal(isOpen)),
  getPaymentPlan_Begin: (query, orgTuruId) =>
    dispatch(getPaymentPlan_Begin(query, orgTuruId)),
  setSelectedCampaign: (campaign) => dispatch(setSelectedCampaign(campaign)),
  checkIfCustomerHasAddress_Begin: () =>
    dispatch(checkIfCustomerHasAddress_Begin()),
  checkPersonelInformation_Begin: () =>
    dispatch(checkPersonelInformation_Begin()),
  isShowMemberApp: () => dispatch(isShowMemberApplications()),
  showError: (message) => dispatch(alertActions.showError(message)),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(SmartCalculation);
